








































































































































































































































































































































































































































































































import {API} from '@/services/api/api';
import {Vue, Component, Watch} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import FilterMenu from '@/components/FilterMenu.vue';
import InspectionList from '@/components/InspectionListComponent.vue';
import Paginition from '@/components/Paginition.vue';
import {getImage, Utils} from '@/utils/Utils';
import {Filter} from '@/utils/Filter';
import moment from 'moment';
import canvasMerge from '@/utils/CanvasMerge';
import VueApexCharts from 'vue-apexcharts';
import TabCard from '@/components/Tabs.vue';
import {getShipList} from '@/services/api/common';

@Component({
  components: {
    FilterMenu,
    InspectionList,
    Paginition,
    VueApexCharts,
    TabCard,
  },
  // computed: {...mapGetters(['shipList'])},
  methods: {
    ...mapActions(['showSuccessToast', 'showErrorToast', 'setShipList']),
  },
})
export default class InspectionReport extends Vue {
  /**
   * @constant chart types
   */
  tabs: Array<Object> = [
    {
      chartName: 'pie',
      displayName: 'Pie Chart',
    },
    {
      chartName: 'bar',
      displayName: 'Bar Chart',
    },
    {
      chartName: 'column',
      displayName: 'Column Chart',
    },
    {
      chartName: 'line',
      displayName: 'Line Chart',
    },
    {
      chartName: 'radar',
      displayName: 'Radar Chart',
    },
    {
      chartName: 'donut',
      displayName: 'Donut Chart',
    },
    {
      chartName: 'area',
      displayName: 'Area Chart',
    },
  ];

  showPDFExcelBtn = false;
  randomColors = [''];
  activeTab = 'pie';
  chartType = 'pie';
  isRenderDotLoaded = false;

  /**
   * @param tabName toggled tab
   * @returns set chart type
   */
  switchTab(tabName) {
    if (tabName === 'column') {
      this.chartType = 'bar';
    } else {
      this.chartType = tabName;
    }
    this.activeTab = tabName;
    this.getchartOptions(tabName);
  }

  chartOptions = {};
  chartSeries = [];

  initialTab: String = 'pie';

  isReportLoaded = true;
  downloadLoader = false;
  setShipList: any;

  /**
   * @constant header  table header
   */
  header = [
    {
      id: 1,
      value: 'month',
      name: 'Month',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      id: 2,
      value: 'name',
      name: 'Name',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      id: 3,
      value: 'countname',
      name: 'CountName',
      headerType: 'Number',
      asdcOrder: false,
      filter: false,
      sortable: false,
    },
  ];

  filteredReports = [];

  chartDataPieExample = {};

  reportList = this.filteredReports;
  shipList: any;
  shipImgLoader = false;
  createdShipImage = '';

  showErrorToast: any;
  showSuccessToast: any;
  optionalInspecId = null;
  isScreenLoading = true;
  shipId = 0;
  selectedDeckId = null;
  reportType = 'summary';
  deckList = [];
  zoneList = [];
  selectedZoneId = null;
  selected = [];
  inspectionTypeId = null;
  currentChartPath = null;

  isAllZoneSelected = false;
  dateFrom = moment(new Date()).subtract(12, 'months').format('YYYY-MM-DD');
  dateUpto = moment(new Date()).format('YYYY-MM-DD');
  findings = [];
  findingId: number = 0;
  isDownloadAll = false;
  frameFrom = null;
  frameUpto = null;
  isClosedChecked = false;
  isDeletedChecked = false;
  isMiscChecked = false;
  isIncludeImgChecked = false;
  isCurrentInsChecked = false;
  inspectionList = [];
  deckDots = [];
  shipDots = [];
  howercontectText = '';

  isCheckBoxClicked = false;

  shipOriginalImg = '';

  /**
   * @constant reportByOptions  report options
   */
  reportByOptions = [
    {id: 1, displayName: 'Finding', value: 'finding', name: 'reportBy'},
    {
      id: 2,
      displayName: 'Voyage Condition',
      value: 'voyage',
      name: 'reportBy',
    },
    {id: 3, displayName: 'Severity', value: 'severity', name: 'reportBy'},
    {id: 5, displayName: 'Logger', value: 'users', name: 'reportBy'},
  ];

  /**
   * @constant inspectionType  Inspections types
   */
  inspectionType = [
    {id: 1, name: 'Inspections', value: 1},
    {id: 2, name: 'Re-Inspections', value: 2},
    {id: 3, name: 'Overdue Re-Inspections', value: 3},
  ];

  /**
   * @constant inspectionTypeCheckBoxes  Inspections  more options
   */
  inspectionTypeCheckBoxes = [
    {id: 1, name: 'Closed', isChecked: false},
    {id: 2, name: 'Deleted', isChecked: false},
    {id: 3, name: 'Misc-Inspections', isChecked: false},
  ];

  /**
   * @constant reportTypes  Report options
   */
  reportTypes = [
    {displayName: 'Summary', value: 'summary'},
    {displayName: 'Detailed', value: 'detailed'},
  ];

  /**
   * @constant imageTypes  Image options
   */
  imageTypes = [
    {id: 1, displayName: 'Standard', value: 'standard'},
    {id: 2, displayName: 'Large', value: 'large'},
    {id: 3, displayName: 'Portrait', value: 'portrait'},
  ];

  imageType = 1;

  reportBy = 'finding';
  asdcOrder = true;
  curentSort = ''; //current sort on which header
  startingPoint = 0; //pagination starting point
  endingPoint = 5; //pagination ending point

  selectTitle = 'Finding';
  selectDynamicId = null;
  selectDynamicName = null;
  isDropDownVisible = false;

  selectedZones = [];
  isAllDeckSelected = false;
  selectedDecks = [];
  isDeckDropDownVisible = false;
  isZoneDropDownVisible = false;
  hidePage = false;

  chartData = [];
  mounted() {
    this.fetchShipList();
    var _this = this;
    /**
     * @param e  listen event
     * @returns add or remove class
     */
    document.addEventListener('click', function (e: any) {
      if (_this.deckList.length > 0 || _this.zoneList.length > 0) {
        if (document.querySelector('#deck-checkboxes')?.contains(e.target)) {
          return;
        } else {
          let element = document.getElementById('deck-checkboxes');
          element?.classList?.remove('show');
        }

        if (document.querySelector('#zone-checkboxes').contains(e.target)) {
          return;
        } else {
          let element = document.getElementById('zone-checkboxes');
          element.classList.remove('show');
        }
      }
    });
  }

  async fetchShipList() {
    try {
      const response = await getShipList();

      if (response?.data.length > 0) {
        this.setShipList();
        this.shipList = response.data;
      } else {
        this.shipList = [];
        this.hidePage = true;
        this.showErrorToast({
          msg: 'Permissions have not been assigned to this user properly. Please assign permissions',
        });
      }
    } catch (e) {
      console.error(e);
      this.hidePage = true;

      this.showErrorToast({
        msg: 'Network Error',
      });
    } finally {
      this.isScreenLoading = false;
    }
  }

  /**
   * @param type  report type
   * @returns call report data function based on input  or call get all inspections function
   */
  onGenerateBtnClick(type) {
    let params = {
      shipid: this.shipId === 0 ? null : this.shipId,
      objDecks: this.selectedDecks.length > 0 ? this.selectedDecks.map((deck) => deck.deckId).join(',') : null,
      ZoneValues: this.selectedZones.length > 0 ? this.selectedZones.map((zone) => zone.zoneId).join(',') : null,
      FrameFrom: this.frameFrom,
      FrameUpto: this.frameUpto,
      type: this.isDownloadAll ? 7 : this.reportByOptions.find((a) => a.value === this.reportBy).id,
      id: this.findingId >= 0 ? this.findingId : -1,
      Inspectiontype: this.inspectionTypeId,
      IsClosed: this.isClosedChecked,
      IsDeleted: this.isDeletedChecked,
      IsMisc: this.isMiscChecked,
      startDate: this.dateFrom,
      endDate: this.dateUpto,
      inspectionId: this.optionalInspecId,
    };

    if (this.reportType === 'detailed' || type === 'inspection') {
      return this.getAllInspections(params);
    } else {
      return this.getReportDataByFindings(params);
    }
  }

  /**
   *
   * @returns get current render chart and pass at the time detail report with image
   */
  async saveCurrentChart() {
    try {
      let currentChartAsSVG = document.getElementsByTagName('svg')[2];

      let param = {
        chartSVG: `${currentChartAsSVG.outerHTML}`,
      };

      const response = await API.getChartForReportPDF(param);
      const data = response.data;

      if (data?.svgFile || data?.pngFile) {
        return data?.pngFile;
      } else {
        this.showErrorToast({msg: 'Network Error'});
        return false;
      }
    } catch (error) {
      console.error(error);

      this.showErrorToast({msg: error});
      return false;
    }
  }
  /**
   * @param type  export report data format
   * @returns  download or open report in PDF, Excel, CSV format
   */
  async getReportDoc(type) {
    this.downloadLoader = true;
    let currentChartSVG = null;
    var isPrint = true;
    let reportType = this.reportType === 'summary' ? true : false;

    if (reportType && type === 'ExportPDF' && this.isIncludeImgChecked) {
      const chartPath = await this.saveCurrentChart();
      if (chartPath) currentChartSVG = chartPath;
    } else currentChartSVG = null;

    let decksArray = [];
    this.selectedDecks.length > 0 ? this.selectedDecks.forEach((me) => decksArray.push(me.deckId)) : [];
    let zonesArray = [];
    this.selectedZones.length > 0 ? this.selectedZones.forEach((me) => zonesArray.push(me.zoneDeckId)) : [];

    let shipName =
      this.shipId && this.shipList.length > 0 ? this.shipList.find((me) => me.shipId === this.shipId).name : null;
    let params = {
      ShipID: this.shipId === 0 ? null : this.shipId,
      DeckId: this.selectedDecks.length > 0 ? this.selectedDecks.map((deck) => deck.deckId).join(',') : null,
      Zones: this.selectedZones.length > 0 ? this.selectedZones.map((zone) => zone.zoneId).join(',') : null,
      Frame: this.frameFrom,
      FrameUpto: this.frameUpto,
      ReportType: this.isDownloadAll ? 7 : this.reportByOptions.find((a) => a.value === this.reportBy).id,
      id: this.findingId >= 0 ? this.findingId : -1,
      InspectionType: this.inspectionTypeId,
      Closed: this.isClosedChecked,
      Deleted: this.isDeletedChecked,
      Misc: this.isMiscChecked,
      startDate: this.dateFrom,
      RealEndDate: this.dateUpto,
      Particular_InspectionId: this.optionalInspecId,
      IncludeImage: this.isIncludeImgChecked,
      ImageSize: this.isIncludeImgChecked ? this.imageType : null,
      CurrentInspection: this.isCurrentInsChecked,
      SummaryReport: reportType,
      ChartImage: currentChartSVG,
      isPrint: true,
    };
    const response = await API.DownloadExcelAndPDF(params, type);
    try {
      this.downloadLoader = true;

      if (response) {
        const data = response;
        let fileURL;
        if (type === 'ExportPDF') {
          fileURL = window.URL.createObjectURL(new Blob([data], {type: 'application/pdf'}));
        } else {
          fileURL = window.URL.createObjectURL(new Blob([data]));
        }
        let link: any = document.createElement('a');
        link.href = fileURL;
        let reportBy = this.getDataType(params.ReportType);
        if (type === 'ExportPDF') {
          return window.open(link.href, '_blank', 'fullscreen=yes'); // open pdf in new window/tab
        } else if (type === 'ExportToCSV') link.setAttribute('download', `${reportBy}.csv`);
        // download csv file
        else link.setAttribute('download', `${reportBy}.xls`); // download excel file

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        this.showErrorToast({msg: 'Network Error'});
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.downloadLoader = false;
    }
  }

  /**
   * @param type  report type
   * @returns  name of export report type based upon selected report type
   */
  getDataType(type) {
    switch (type) {
      case 1:
        return 'Report_By_Findings';
      case 2:
        return 'Report_By_Voyage';
      case 3:
        return 'Report_By_Severity';
      case 5:
        return 'Report_By_Logger';
      case 7:
        return 'Report_By_Ship';
    }
  }

  /**
   * @param params  parameter to generate/fetch report data
   * @returns  report table data and chart data  based on parameter
   */
  async getReportDataByFindings(params) {
    this.isReportLoaded = false;

    this.chartData = [];
    try {
      const response = await API.fetchReportDataByFindings(params);

      if (response.data) {
        const data = response.data.objFindingReport;
        this.filteredReports = data;

        this.reportList = data;
        this.chartData = data;
        this.activeTab = 'pie';
        this.chartType = 'pie';
        this.getchartOptions(this.chartType);

        this.mapDataToChart(data);
      } else {
        this.showErrorToast({msg: response.message});
      }
    } catch (error) {
      console.error({error});

      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.isReportLoaded = true;
    }
  }

  /**
   * @param data  fetched report data
   * @returns  mapp data to chart
   */
  mapDataToChart(data) {
    let chartData = {
      labels: [],

      datasets: [
        {
          data: [],
          backgroundColor: [],
          borderColor: [],
          borderWidth: 2,
          min: 0,
          stack: 'bar',
          minBarLength: 1,
        },
      ],
    };

    data.forEach((me) => {
      chartData.labels.push(me.name);
      chartData.datasets[0].data.push(me.countName);
      chartData.datasets[0].backgroundColor.push(me.color);
      chartData.datasets[0].borderColor.push(me.color);
    });
    this.chartDataPieExample = chartData;
  }

  /**
   * @param params  parameter to generate/fetch report data
   * @returns  inspection list
   */
  async getAllInspections(param) {
    try {
      const response = await API.getInspectionListByShip(param);
      if (response.data) {
        const data = response.data;
        this.inspectionList = data;
        this.isRenderDotLoaded ? this.renderDot() : '';
      } else if (response.errors) {
        if (response.errors.ShipId) {
          this.showErrorToast({msg: response.errors.ShipId[0]});
        } else if (response.errors.InspectionId) {
          this.showErrorToast({msg: response.errors.InspectionId[0]});
        } else if (response.errors.FromDate) {
          this.showErrorToast({msg: response.errors.FromDate[0]});
        } else if (response.errors.ToDate) {
          this.showErrorToast({msg: response.errors.ToDate[0]});
        }
      } else {
        this.inspectionList = [];
      }
    } catch (error) {
      console.error({error});

      this.showErrorToast({msg: 'Network error'});
    }
  }

  /**
   * @returns toggle deck multi select
   */
  showDeckDropDown() {
    let element = document.getElementById('deck-checkboxes');
    if (!element.classList.contains('show')) element.classList.add('show');
    else element.classList.remove('show');
  }

  /**
   * @returns toggle zone multi select
   */
  showZoneDropDown() {
    let element = document.getElementById('zone-checkboxes');
    if (!element.classList.contains('show')) element.classList.add('show');
    else element.classList.remove('show');
  }

  /**
   * @param isZoneSelected event
   * @param zone selected zone
   * @returns add or remove zone in zone multi select
   */
  onZoneSelect(isZoneSelected, zone) {
    if (this.selectedZones.some((element) => element.zoneId === zone.zoneDeckId)) {
      this.selectedZones = this.selectedZones.filter((me) => me.zoneId !== zone.zoneDeckId);
      this.isAllZoneSelected = false;
    } else {
      this.selectedZones.push({
        zoneId: zone.zoneDeckId,
        zoneName: zone.zoneName,
      });
      if (this.selectedZones.length === this.zoneList.length) this.isAllZoneSelected = true;
    }
  }

  /**
   * @returns select or deselect all zones
   */
  onSelectAllZoneClick() {
    this.isDropDownVisible = true;
    if (this.selectedZones.length === this.zoneList.length) {
      this.isAllZoneSelected = false;
      this.selectedZones = [];
    } else {
      this.isAllZoneSelected = true;
      this.selectedZones = this.zoneList.map((me) => {
        return {
          zoneId: me.zoneDeckId,
          zoneName: me.zoneName,
        };
      });
      let element = document.getElementById('zone-checkboxes');
      element.classList.remove('show');
    }
  }

  /**
   * @param e event
   * @param deck selected deck
   * @returns add or remove deck in deck multi select
   */
  onDeckSelect(e, deck) {
    this.isCheckBoxClicked = true;
    if (this.selectedDecks.some((element) => element.deckId === deck.drawingId)) {
      this.selectedDecks = this.selectedDecks.filter((me) => me.deckId !== deck.drawingId);

      this.isAllDeckSelected = false;
    } else {
      this.selectedDecks.push({
        deckId: deck.drawingId,
        deckName: deck.name,
      });
      if (this.selectedDecks.length === this.deckList.length) this.isAllDeckSelected = true;
    }
  }

  /**
   * @returns select or deselect all decks
   */
  onSelectAllDeckClick() {
    this.isDeckDropDownVisible = true;
    if (this.selectedDecks.length === this.deckList.length) {
      this.isAllDeckSelected = false;
      this.selectedDecks = [];
    } else {
      this.isAllDeckSelected = true;
      this.selectedDecks = this.deckList.map((me) => {
        return {
          deckId: me.drawingId,
          deckName: me.name,
        };
      });

      let element = document.getElementById('deck-checkboxes');
      element.classList.remove('show');
    }
  }

  /**
   * @param reportBy report by selected option
   * @returns call respective list based upon input
   */
  getReportBasedOn() {
    switch (this.reportBy) {
      case 'voyage':
        return this.getReportByGraphType('Voyage', 'fetchVoyageConditions');
      case 'severity':
        return this.getReportByGraphType('Severity', 'fetchInspectionSeverity');
      case 'users':
        return this.getReportByGraphType('Logger', 'fetchInspectionCreators');
      default:
        return this.getReportByGraphType('Findings', 'fetchInspectionFindings');
    }
  }
  //sorting list
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredReports);
    this.asdcOrder = sorted;
  }

  //filter data based upon string parameters
  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.reportList);

    this.filteredReports = filteredData;
    this.resetPagination();
  }

  //reset all filters and show current list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.filteredReports = this.reportList;
      this.resetPagination();
    }
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }

  //reset pagination with filter
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  /**
   * @returns fetch all  decks and zones based on selected ship
   */
  async getDeckAndZones() {
    try {
      this.isScreenLoading = true;
      const decksParam = {
        alldecks: 1,
        withoutzones: 0,
        withoutcenter: 0,
      };

      const zonesParam = {
        allzones: 1,
        withoutframe: 0,
      };

      const decks = API.fetchEmptyDecksByShipId(decksParam, this.shipId);
      const zones = API.fetchZoneListByShipID(zonesParam, this.shipId);

      const response = await Promise.all([decks, zones]);
      this.deckList = [];
      this.zoneList = [];
      this.selectedDecks = [];
      this.selectedZones = [];
      this.inspectionList = [];

      this.deckList = response[0]?.data?.drawings;
      this.zoneList = response[1]?.data;

      if (this.deckList?.length < 1) {
        this.showErrorToast({msg: 'No decks found for this ship'});
        if (this.zoneList === undefined) {
          this.showErrorToast({msg: response[1].error});
        }
      } else {
        this.onGenerateBtnClick('inspection');
      }
    } catch (error) {
      this.showErrorToast({msg: error});
    } finally {
      this.isScreenLoading = false;
    }
  }

  /**
   * @param title  selected report type
   * @param fetchMethod  method in api
   * @returns list of data based on selected option
   */
  async getReportByGraphType(title, fetchMethod) {
    this.findingId = title === 'Voyage' ? -1 : 0;

    try {
      let response = await API[fetchMethod]();

      if (response.data) {
        const data = response.data;
        const key = Object.keys(data[0]);

        this.findings = data;

        this.selectTitle = title;
        this.selectDynamicId = key[0];
        if (title === 'Logger') this.selectDynamicName = key[2];
        else this.selectDynamicName = key[1];
        this.onGenerateBtnClick('report');
      } else {
        return this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      console.error(error);
      return this.showErrorToast({msg: 'Network Error'});
    }
  }

  /**

 * @returns set inspection start date from start of project
 */
  onCurrentInspectionClick() {
    this.isCurrentInsChecked = this.isCurrentInsChecked;
    this.dateFrom = '2020-01-01';
  }

  /**

   * @returns fetch all decks and zones on selected ship or hide/remove selected deck ans zone
   */
  async onShipChange() {
    if (this.shipId !== 0) {
      await this.getDeckAndZones();

      this.selectedDeckId = null;
      this.selectedZoneId = null;
      let ship = this.shipList.find((me) => me.shipId === this.shipId);
      this.shipOriginalImg = await getImage(ship.imagePath);
    } else {
      this.selectedDeckId = null;
      this.selectedZoneId = null;
    }
  }

  /**

 * @returns on ship image load generate inspection dot and render new ship image with inspection dot on respective position
 */
  shipImageLoad() {
    let _this = this;
    this.shipImgLoader = false;
    this.renderDot();

    window.onmousemove = function (e) {
      const main = e.target as HTMLImageElement;
      if (main.classList.contains('shipimg')) {
        //	Content of dot which is hovered
        const $target = main.nextElementSibling as HTMLElement;
        //

        //	Only work with hovered target
        //	Add visible class hovered elem to distinguish
        if (!$target.classList.contains('visible')) {
          $target.classList.add('visible');
        } else {
          //	Get viewport offset of tooltip element
          let offset = $target.parentElement.getBoundingClientRect();
          //	Tooltip distance from mouse(px)
          let tipDist = 15;
          //	Calc and set new tooltip location
          $target.style.top = e.clientY - offset.top + tipDist + 'px';
          $target.style.left = e.clientX - offset.left + tipDist + 'px';

          offset = main.getBoundingClientRect();
          let x = e.clientX - offset.left;
          let y = e.clientY - offset.top;
          let cw = main.clientWidth;
          let ch = main.clientHeight;
          let iw = main.naturalWidth;
          let ih = main.naturalHeight;
          let posx = (x / cw) * iw;
          let posy = (y / ch) * ih;

          let detactMouse = false;
          _this.shipDots.map((dots) => {
            if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.003 * main.naturalWidth) {
              //
              _this.howercontectText =
                'Click here to view inspection : ' + dots.inspectionCode + ' (ID: ' + dots.inspectionID + ')';

              main.style.cursor = 'pointer';
              detactMouse = true;
            }
          });

          if (!detactMouse) {
            const ship = _this.shipList.find((me) => {
              return me.shipId === _this.shipId;
            });

            const decks = ship.drawing;

            const deck = decks.find((d) => d.topY <= posy && posy <= d.bottomY);
            if (deck) {
              main.style.cursor = 'unset';
            } else {
              _this.howercontectText = '';
              main.style.cursor = 'unset';
            }
          }
        }
      } else if (main.classList.contains('deckimg')) {
        //	Content of dot which is hovered
        let imageRef = _this.$refs.deckImageRef as HTMLImageElement;
        let offset = imageRef.getBoundingClientRect();
        let x = e.clientX - offset.left;
        let y = e.clientY - offset.top;
        let cw = main.clientWidth;
        let ch = main.clientHeight;
        let iw = main.naturalWidth;
        let ih = main.naturalHeight;
        let posx = (x / cw) * iw;
        let posy = (y / ch) * ih;

        let detactMouse = false;
        _this.deckDots.map((dots) => {
          if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.005 * main.naturalWidth) {
            _this.howercontectText =
              'Click here to view inspection : ' + dots.inspectionCode + ' (ID: ' + dots.inspectionID + ')';
            main.style.cursor = 'pointer';
            detactMouse = true;
          }
        });
        if (!detactMouse) {
          main.style.cursor = 'unset';
          _this.howercontectText = '';
        }
      } else {
        //	Remove visible class
        var content = document.getElementsByClassName('hovercontent');
        for (var i = 0; i < content.length; i++) {
          content[i].classList.remove('visible');
        }
      }
    };
  }

  /**

 * @returns create inspection dots on respective position on ship
 */
  renderDot() {
    this.isRenderDotLoaded = true;

    this.shipDots = [];
    if (!this.shipImgLoader && this.shipOriginalImg && this.inspectionList.length > 0) {
      let imageRef = this.$refs.shipImageRef as HTMLImageElement;
      this.inspectionList.map((inspection) => {
        const points = inspection.additionalInfo;
        let deckWidth = inspection.deckImageWidth;
        let deckHeight = inspection.deckImageHeight;
        let shipHeight = inspection.shipImageHeight;
        let shipWidth = inspection.shipImageWidth;
        let y = null;
        let framePosition = null;
        if (inspection.isMisc) {
          y = (points.deckTopY + points.deckBottomY) / 2;
          let totalFrame = points.frameUpto - points.frameFrom;
          let pixelsCountInZone = points.zoneEndPoint - points.zoneStartPoint;
          let pixelsInEachframes = pixelsCountInZone / totalFrame;
          let thisframePosition = points.frameUpto - inspection.frameNumber;
          framePosition = points.zoneStartPoint + thisframePosition * pixelsInEachframes;
        } else {
          y = (points.deckTopY + points.deckBottomY) / 2;
          framePosition = points.location_X;
        }

        let widthPoint = (shipWidth / deckWidth) * framePosition;
        let heightPoint = y;

        this.shipDots.push({
          x: widthPoint,
          y: heightPoint,
          radius: 0.003 * imageRef.naturalWidth,
          color: Utils.getBackgroundColor(inspection.severity),
          inspectionID: inspection.inspectionID,
          inspectionCode: inspection.inspectionCode,
        });
      });
      this.mergeImage();
    }
  }

  /**

 * @returns merge inspection dot with severity color with ship image and returns new canvas ship image in base64 format
 */
  mergeImage() {
    let img;
    let dots;

    img = this.shipOriginalImg;
    dots = this.shipDots;

    canvasMerge(img, dots, {
      crossOrigin: 'anonymous',
      drawType: 'circle',
    }).then((b64) => {
      this.createdShipImage = b64;
    });
  }

  /**
   * @param e event

   * @returns navigate to respective inspection
   */
  async onShipClick(e) {
    let imageRef = this.$refs.shipImageRef as HTMLImageElement;

    let offset = imageRef.getBoundingClientRect();
    let x = e.clientX - offset.left;
    let y = e.clientY - offset.top;
    let cw = imageRef.clientWidth;
    let ch = imageRef.clientHeight;
    let iw = imageRef.naturalWidth;
    let ih = imageRef.naturalHeight;
    let posx = (x / cw) * iw;
    let posy = (y / ch) * ih;

    let detactMouse = false;
    this.shipDots.map((dots) => {
      if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.003 * imageRef.naturalWidth) {
        this.$router.push(`/view-inspection/` + dots.inspectionID);
        detactMouse = true;
      }
    });
  }

  @Watch('shipList', {immediate: true})
  loadShips() {
    if (this.shipList?.length > 0) this.isScreenLoading = false;
  }

  @Watch('shipId', {immediate: true})
  fetchDecks() {
    if (this.shipId !== 0) {
      this.onShipChange();
    } else this.selectedDeckId = null;
    this.selectedZoneId = null;
  }

  @Watch('reportBy', {immediate: true})
  getDynamicSelectData() {
    this.getReportBasedOn();
  }

  @Watch('reportType', {immediate: true})
  checkDownloadAll() {
    if (this.reportType !== 'summary') {
      this.isDownloadAll = true;
      this.isCurrentInsChecked = true;
    }
  }

  /**
   * @param chartType  selected tab or report chart type view
   * @returns render selected chart based on data
   */
  getchartOptions(chartType) {
    switch (chartType) {
      case 'pie':
        this.chartSeries = [];
        this.chartData.map((data: any) => {
          this.chartSeries.push(data.countName);
        });

        this.chartOptions = {
          chart: {
            width: 380,
            type: 'pie',
          },

          labels: this.chartData.map((d) => d.name),
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            enabled: true,
            theme: 'dark',
          },
          colors: this.chartData.map((d, i) => d.color || this.getRandomColor(i)),
          legend: {
            position: 'bottom',
            fontSize: '14px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            labels: {
              colors: this.chartData.map((d, i) => d.color || this.getRandomColor(i)),
              useSeriesColors: false,
            },
          },
        };
        break;

      case 'bar':
        this.chartSeries = [];
        this.chartSeries = [
          {
            name: '',
            data: this.chartData.map((d: any) => d.countName),
          },
        ];

        this.chartOptions = {
          chart: {
            height: 350,
            type: 'bar',
            toolbar: {
              show: false,
            },
          },

          tooltip: {},

          colors: this.chartData.map((d, i) => d.color || this.getRandomColor(i)),
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          xaxis: {
            categories: this.modifyNameForChart(this.chartData),
            labels: {
              style: {
                colors: ['#ffffff'],
                fontSize: '12px',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: this.chartData.map((d, i) => d.color || this.getRandomColor(i)),
                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
          },
        };
        break;
      case 'column':
        this.chartSeries = [];
        this.chartSeries = [
          {
            name: '',
            data: this.chartData.map((data: any) => data.countName),
          },
        ];
        this.chartOptions = {
          tooltip: {
            style: {
              fontSize: '12px',
            },
          },
          // ...{
          chart: {
            height: 350,
            type: 'bar',
            toolbar: {
              show: false,
            },
          },
          title: {
            align: 'right',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
          },
          colors: this.chartData.map((d, i) => d.color || this.getRandomColor(i)),
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              horizontal: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          xaxis: {
            categories: this.modifyNameForChart(this.chartData),

            type: 'category',
            labels: {
              trim: false,
              minHeight: 150,
              style: {
                colors: this.chartData.map((d: any, i) => d.color || this.getRandomColor(i)),
                fontSize: '12px',
              },
            },
          },

          yaxis: {
            labels: {
              style: {
                colors: ['#ffffff'],
                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
          },
        };

        break;

      case 'line':
        this.chartSeries = [];
        this.chartSeries = [
          {
            name: '',
            data: this.chartData.map((data: any) => data.countName),
          },
        ];
        console.log(this.chartData, this.chartSeries);
        this.chartOptions = {
          tooltip: {
            intersect: false,

            style: {
              fontSize: '12px',
            },
          },

          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },

          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            row: {
              colors: ['transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            categories: this.modifyNameForChart(this.chartData),

            type: 'category',
            labels: {
              trim: false,
              minHeight: 150,
              style: {
                colors: this.chartData.map((d, i) => d.color || this.getRandomColor(i)),
                fontSize: '12px',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: ['#ffffff'],

                fontSize: '12px',
              },

              trim: false,
            },
            floating: false,
            min: 0,
            max: this.getMaxValue(this.chartData) + 10,
            tickAmount: 5,
          },
        };
        break;

      case 'radar':
        this.chartSeries = [];
        this.chartSeries = [
          {
            name: '',
            data: this.chartData.map((data: any) => data.countName),
          },
        ];
        this.chartOptions = {
          chart: {
            height: 350,
            type: 'bar',
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          tooltip: {
            enabled: true,
            intersect: true,
            // shared:true,

            style: {
              fontSize: '12px',
            },
            onDatasetHover: {
              highlightDataSeries: false,
            },
            x: {
              formatter: function (val) {
                return val;
              },
            },
            y: {
              formatter: function (val) {
                return val;
              },
            },

            z: {
              formatter: function (val) {
                return val;
              },
            },
          },

          plotOptions: {
            radar: {
              columnWidth: '45%',
              distributed: true,
              horizontal: true,
              polygons: {
                strokeColor: '#e8e8e8',
              },
            },
          },

          legend: {
            show: false,
          },
          xaxis: {
            categories: this.chartData.map((d) => d.name),
            labels: {
              style: {
                colors: this.chartData.map((d, i) => d.color || this.getRandomColor(i)),
                fontSize: '12px',
              },
            },
          },
        };
        break;

      case 'donut':
        this.chartSeries = [];
        this.chartData.map((data: any) => {
          this.chartSeries.push(data.countName);
        });
        this.chartOptions = {
          chart: {
            width: 380,
            type: 'donut',
            toolbar: {
              show: false,
            },
          },
          tooltip: {
            theme: 'dark',

            style: {
              fontSize: '12px',
              color: '#000000',
            },
          },
          labels: this.chartData.map((d) => d.name),
          dataLabels: {
            enabled: false,
          },
          legend: {
            position: 'bottom',
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            labels: {
              colors: this.chartData.map((d, i) => d.color || this.getRandomColor(i)),
              useSeriesColors: false,
            },
          },
          colors: this.chartData.map((d, i) => d.color || this.getRandomColor(i)),
        };

        break;

      case 'area':
        this.chartSeries = [];
        this.chartSeries = [
          {
            name: '',
            data: this.chartData.map((data: any) => data.countName),
          },
        ];
        this.chartOptions = {
          chart: {
            height: 350,
            type: 'arae',
            toolbar: {
              show: false,
            },
          },
          tooltip: {
            style: {
              fontSize: '12px',
            },
          },
          labels: this.chartData.map((d) => d.name),
          colors: this.chartData.map((d, i) => d.color || this.getRandomColor(i)),
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          stroke: {
            curve: 'straight',
          },
          xaxis: {
            categories: this.modifyNameForChart(this.chartData),

            type: 'category',

            labels: {
              style: {
                colors: this.chartData.map((d, i) => d.color || this.getRandomColor(i)),
                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: ['#ffffff'],

                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
            min: 0,
            max: this.getMaxValue(this.chartData),
            tickAmount: this.getMaxValue(this.chartData),
          },
        };
        break;
    }
  }

  /**
   *
   * @returns download rendered ship image
   */
  async onDownLoadShipClick() {
    const data = await Utils.downloadImage(this.createdShipImage || this.shipOriginalImg, 'Ship');

    data.click();
  }

  /**
   * @param i current index
   * @param forYAxis for chart's X-axis or Y-axis
   * @returns when color is not defined for any module we set random color to show respective chart
   */
  getRandomColor(i, forYAxis = false) {
    if (forYAxis && (this.reportBy !== 'finding' || 'severity')) {
      return '#ffffff';
    } else {
      var colors = [
        '#6495ED',
        '#FF69B4',
        '#90EE90',
        '#87CEFA',
        '#7B68EE',
        '#FF6347',
        '#F0F8FF',
        '#ADD8E6',
        '#FFA07A',
        '#9370DB',
        '#4682B4',
        '#D8BFD8',
        '#9ACD32',
      ];

      return colors[i];
    }
  }

  /**

   * @returns  set dynamic height of chart
   */
  get getHeight() {
    return this.chartType !== 'radar' ? 350 : 500;
  }

  /**
   * @param data table data item

   * @returns navigate to inspection list page based on selected report type
   */
  onCountNameClick = (data) => {
    let type = data.findingType;

    if (type === 'Severity') {
      return this.$router.push(`/inspection-list/severity/${data.id}`);
    } else if (type === 'Finding') {
      return this.$router.push(`/inspection-list/findings/${data.id}`);
    } else if (type === 'Inspector') {
      return this.$router.push(`/inspection-list/inspector/${data.id}`);
    } else if (type === 'Ship') {
      return this.$router.push(`/inspection-list/ship/${data.id}`);
    } else if (type === 'Voyage') {
      return this.$router.push(`/inspection-list/voyage/${data.id}`);
    }
    //
  };

  /**
   * @param data   inspection data
   * @returns categoty name for chart in array form to show large name in new line
   */
  modifyNameForChart = (data) => {
    let stringAsArray = [];

    data.forEach((element) => {
      if (element.name.split(' ').length > 0) {
        stringAsArray.push(element.name.split(' '));
      }
    });
    return stringAsArray;
  };

  /**
   * @returns when  report data is less than 2 element then not rendering radar chart as it does not show properly with 2 or less element
   */
  get getModifiedTabs() {
    if (this.filteredReports?.length < 3) return this.tabs.filter((me: any) => me.chartName !== 'radar');
    else return this.tabs;
  }

  /**

   * @returns  toggle download or export report in PDF ,Excel ,CSV format
   */
  toggledDownloadBtns() {
    this.showPDFExcelBtn = !this.showPDFExcelBtn;
  }

  /**
   * @returns get maximum value or count of inspection
   */
  getMaxValue = (data) => {
    let counts = data.map((me) => me.countName);
    return Math.max(...counts);
  };
}
